<template>
  <div>
    <div style="display: flex; align-items: center">
      <base-bread-crumb
        :currBreadCrumb="currBreadCrumb"
        :isShowPortal="false"
      ></base-bread-crumb>
    </div>
    <div class="ccui-notice-app-container-detail">
      <div class="ccui-notice-app-container-detail-body clearfix">
        <div class="ccui-notice-app-container-detail-left">
          <div class="notice-title">{{ pageData.schemeName }}</div>
          <div class="notice-project-info">
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.projectCode") }}：</span
              >{{ pageData.schemeCode }}
            </div>
            <div class="notice-project-info-li">
              <span>{{ $t("page.content.publishTime") }}：</span
              >{{ pageData.noticeReleaseTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="template-notice-detail-body ccui-clearfix">
      <!--左侧内容-->
      <div
        class="template-notice-detail-left"
        :style="{
          'min-height': leftMinHeight,
          width: '1120px'
        }"
      >
        <div class="notice-detail-title">{{ $t("page.content.notice") }}</div>
        <div class="notice-detail-ul clearfix">
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeTitle") }}：</span
            >
            <div class="notice-detail-li-con">{{ pageData.noticeTitle }}</div>
          </div>
          <div class="notice-detail-li ccui-clearfix">
            <span class="notice-detail-li-title"
              >{{ $t("page.content.noticeContent") }}：</span
            >
            <div
              class="notice-detail-li-con rich-text"
              v-html="pageData.noticeContent"
            ></div>
          </div>
          <!-- <div
            class="notice-detail-li ccui-clearfix"
            v-if="
              $route.query.purchaseType === '0' ||
              $route.query.purchaseType === '3'
            "
          >
            <span class="notice-detail-li-title"
              >{{ $t("page.content.contractInfo") }}：</span
            >
            <div
              class="notice-detail-li-con rich-text"
              v-html="pageData.linkInfo"
            ></div>
          </div> -->
          <!--未登录时展示会员提示框-->
          <div class="notice-detail-li ccui-clearfix" v-if="!isLogin">
            <div class="notice-login-tip">
              <p class="notice-login-tip-desc">
                {{ loginTipText.line1Prefix
                }}<a class="notice-login-tip-link" @click="openLogin">{{
                  loginTipText.login
                }}</a>
              </p>
              <p class="notice-login-tip-desc">
                {{ loginTipText.line2Prefix
                }}<a class="notice-login-tip-link" @click="openRegister">{{
                  loginTipText.register
                }}</a
                >{{ loginTipText.line2Suffix }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { commonTableWidth } from "@/setting/setting";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import globalConfig from "@/setting/setting";
import Cookies from "js-cookie";
import {
  qryNoticeContent,
  getSystemCurrentTime
} from "@/app/shop/api/shoppingSP";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "noticeDetail",
  mixins: [mixinHomePage],
  components: {
    baseBreadCrumb
  },
  data() {
    return {
      currBreadCrumb: [
        { title: "采购公告", path: "/procurementNotice" },
        { title: "公开采购公告", path: "/procurementNotice" }
      ],
      schemeStatus: "",
      fileHead: [
        { label: this.$t("page.content.fileName"), prop: "fileName" },
        { label: this.$t("page.content.fileDesc"), prop: "fileSumm" },
        {
          label: this.$t("page.content.operation"),
          slot: "opp",
          align: "center",
          width: this.$TW.operationWidth
        }
      ],
      packageHead: [
        { label: this.$t("page.content.equipmentName"), prop: "matName" },
        {
          label: this.$t("page.content.equipmentDesc"),
          prop: "matDesc",
          width: this.$TW.equipmentDescWidth
        },
        { label: this.$t("page.content.transMatName"), prop: "transMatName" },
        // { label: this.$t("page.content.num"), prop: "convNum" },
        { label: this.$t("page.content.tax"), prop: "exchangeRangeLabel" },
        { label: this.$t("page.content.unit"), prop: "convMeasureUnitName" }
      ],
      noticeHead: [
        {
          label: this.$t("page.content.type"),
          prop: "noticeTypeName",
          width: 150
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          slot: "noticeTitle"
        },
        {
          label: this.$t("page.content.link"),
          prop: "purStepName",
          width: 150
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "createTime",
          width: commonTableWidth.dateTimeWidth
        }
      ],
      subPackageFlag: "", //是否分包
      packageList: [],
      matDetailList: [],
      pageData: {},
      relateNoticeList: [], //相关公告列表
      schemeObj: {
        // opUnitName: this.$route.query.opUnitName, //发布单位
        // schemeName: this.$route.query.schemeName, //项目名称
        // schemeCode: this.$route.query.schemeCode, //项目编号
      },
      cumulativeAmount: 0, //累计金额
      projectNum: 0, //累计采购项目数
      inquiryProjectNum: 0, //询价项目数量
      competeProjectNum: 0, //竞价项目数量
      otherNoticeList: [], //该单位还在采购的公告列表
      noticeEndTime: "",
      currentTime: "",
      timeObj: {
        day: 0,
        hour: 0,
        minute: 0,
        second: 0
      },
      timer: "",
      timerHttp: "",
      leftMinHeight: 0,
      noticeStatus: "",
      checkFlag: "",
      messageTip: "", //提示信息
      supInfo: this.$store.state.user.supInfo || {},
      accessToken: this.$store.state.user.accessToken,
      isShow1: false,
      isShow2: false
    };
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    },
    isLogin() {
      return !!this.$store.state.user.accessToken;
    },
    loginTipText() {
      return this.languagezh_cn
        ? {
            line1Prefix: "查看更多内容，请",
            login: "【登录】",
            line2Prefix: "未注册用户，可点击",
            register: "【注册】",
            line2Suffix: "免费注册"
          }
        : {
            line1Prefix: "To view more content, please ",
            login: "[Login]",
            line2Prefix: "Not registered? Click ",
            register: "[Register]",
            line2Suffix: " to register for free"
          };
    }
  },
  activated() {
    if (this.$route.query.type == 1) {
      this.currBreadCrumb[1] = {
        title: "公开采购公告",
        path: "/procurementNotice"
      };
    } else if (this.$route.query.type == 2) {
      this.currBreadCrumb[1] = {
        title: "邀请采购公告",
        path: "/procurementNotice?type=2"
      };
    }
    this.init();
    // this.setBreadCrumb();
  },
  deactivated() {
    this.currBreadCrumb = [
      { title: "采购公告", path: "/procurementNotice" },
      { title: "公开采购公告", path: "/procurementNotice" }
    ];
    clearInterval();
  },
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    init() {
      this.isShow1 = false;
      this.isShow2 = false;
      //查询公告信息及附件列表
      let obj = {
        baseAppId: this.$route.query.baseAppId,
        noticeId: this.$route.query.noticeId
        // purStep: 1,
        // qryFileFlag: true,
      };
      qryNoticeContent(obj).then(res => {
        if (res.data.code === "0" && res.data.data) {
          if (res.data.data.purchaseCategory != "8") {
            //采购类型不是物流去掉物流特色字段
            this.packageHead.splice(2, 1);
          }
          this.pageData = res.data.data;
          this.$set(
            this.noticeHead[2],
            "isHidden",
            this.pageData.purStep !== "1"
          );
          this.currBreadCrumb.push({
            title: this.pageData.noticeTitle
          });
          this.schemeStatus = res.data.data.schemeStatus;
          // this.schemeObj.noticeStartTime = this.pageData.noticeStartTime;
          this.noticeEndTime = this.pageData.firstRoundEndTime;
          this.currentTime =
            this.UTCToLocalTimeString(res.headers.date) || new Date().getTime();
          // this.schemeObj.isNotShoime = this.pageData.isNotShowTime;
          clearInterval(this.timer);
          let that = this;
          this.timer = setInterval(that.getTime, 1000);
          //每隔10s请求一次接口同步下时间，因为窗口切换后浏览器基于节约资源定时器会有延迟
          clearInterval(that.getTimerHttp);
          this.timerHttp = setInterval(that.getTimerHttp, 30000);
          this.noticeStatus = this.pageData.noticeStatus;
          this.isShow2 = true;
        }
      });
    },
    // setBreadCrumb() {
    //   this.currBreadCrumb = [];
    //   const handlerClick = searchType => {
    //     const serchTypeMap = {
    //       首页: "",
    //       采购公告: "procurementNotice"
    //     };
    //     location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
    //       serchTypeMap[searchType]
    //     }`;
    //   };
    //   const source = this.$route.query.searchType;
    //   if (this.$route.query.isJRZL === "1") {
    //     this.currBreadCrumb.push({
    //       title: source,
    //       clickFn: this.$route.query.isJRZL === "1" ? handlerClick : null,
    //       to: "/"
    //     });
    //   }
    // },
    back() {
      const serchTypeMap = {
        首页: "",
        采购公告: "procurementNotice"
      };
      const searchType = this.$route.query.searchType;
      location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
        serchTypeMap[searchType]
      }`;
    },
    getTimerHttp() {
      getSystemCurrentTime({}).then(res => {
        if (res.headers.date) {
          this.currentTime =
            this.UTCToLocalTimeString(res.headers.date) || new Date().getTime();
        }
      });
    },
    UTCToLocalTimeString(d) {
      let date = new Date(d);
      let timeOffsetInHours = new Date().getTimezoneOffset() / 60 + 8; //这里的 8是时区，东八区为北京时间，PS：东区为正数 西区为负数
      date.setHours(date.getHours() + timeOffsetInHours);
      console.log(date, "这是转东八区后的d", date.getTime());
      return date.getTime();
    },
    getTime() {
      let obj =
        (new Date(
          (this.noticeEndTime ?? "2000-01-01").replace(/-/g, "/")
        ).getTime() -
          this.currentTime) *
        1000;
      if (obj < 0) {
        clearInterval(this.timer);
        clearInterval(this.getTimerHttp);
        return;
      }
      let day = Math.floor(obj / (24 * 3600 * 1000 * 1000));

      let leave1 = obj % (24 * 3600 * 1000 * 1000);
      let hour = Math.floor(leave1 / (3600 * 1000 * 1000));
      let leave2 = leave1 % (3600 * 1000 * 1000);
      let minutes = Math.floor(leave2 / (60 * 1000 * 1000));

      let leave3 = leave2 % (60 * 1000 * 1000);
      let second = Math.floor(leave3 / (1000 * 1000));

      this.timeObj.day = day;
      this.timeObj.hour = hour;
      this.timeObj.minute = minutes;
      this.timeObj.second = second;
      this.currentTime += 1000;
    },

    //供应商在线投标流程
    handleProcess() {
      let url = this.$router.resolve({
        path: "/announcementDetail",
        query: {
          ...this.$route.query,
          id: globalConfig.faqId,
          source: "1"
        }
      });
      window.open(url.href, "_blank");
    },
    //跳转登录
    openLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //跳转注册
    openRegister() {
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_SRA_URL
      )}/index`;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.getTimerHttp);
  }
};
</script>

<style scoped lang="scss">
.template-detail-body .detail-box .detail-info {
  width: calc(100% - 240px);
}
/deep/ .template-detail-body .detail-box {
  margin-top: 20px;
  margin-bottom: 0;
}
/deep/
  .ccui-notice-app-container-detail
  .ccui-notice-app-container-detail-body
  .ccui-notice-app-container-detail-right {
  width: inherit;
  .notice-timeout-btnEn {
    width: 228px;
  }
  .notice-timeout-btn-bottom {
    margin-top: 90px;
  }
}
.messageTip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: red;
  display: block;
  width: 200px;
}
.time {
  color: #ff142f;
  margin-left: 8px;
  margin-right: 8px;
}
.notice-login-tip {
  margin-top: 40px;
  border: 1px solid #79bbff;
  background-color: #f0f7ff;
  padding: 20px;
  text-align: center;
  .notice-login-tip-title {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .notice-login-tip-desc {
    color: #333;
    font-size: 14px;
  }
  .notice-login-tip-link {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
